import { useMutation, MutationFunction } from '@tanstack/react-query';

import { updateChangeCadastral } from 'services';

import type { ChangeCadastralResponse, RequestChangeCadastralType } from 'domains/change-cadastral';

const userChangeCadastralTyped: MutationFunction<
  ChangeCadastralResponse,
  RequestChangeCadastralType
> = updateChangeCadastral;

export const useUpdateChangeCadastral = () => {
  return useMutation<ChangeCadastralResponse, Error, RequestChangeCadastralType>(
    userChangeCadastralTyped
  );
};
